var map = {
	"./actions/dist/index.ts": "733a",
	"./auth/dist/index.ts": "621b",
	"./bonus/dist/index.ts": "692a",
	"./booking/dist/index.ts": "6cb3",
	"./catalog/dist/index.ts": "157e",
	"./feedback/dist/index.ts": "f534",
	"./getwallet/dist/index.ts": "64ef",
	"./gifts/dist/index.ts": "38ac",
	"./history/dist/index.ts": "f487",
	"./home/dist/index.ts": "e89c",
	"./maps/dist/index.ts": "ea58",
	"./news/dist/index.ts": "509d",
	"./notifications/dist/index.ts": "bec6",
	"./pages/dist/index.ts": "5b0c",
	"./panelmenu/dist/index.ts": "5640",
	"./polls/dist/index.ts": "785c",
	"./referral/dist/index.ts": "6065",
	"./related/dist/index.ts": "25ab",
	"./specialoffer/dist/index.ts": "9c6c",
	"./stampcard/dist/index.ts": "a500"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e7fd";